{
  "zh-TW": {
    "empty": {
      "headlines": {
        "default": "There's nothing to see here...",
        "forName": "未找到 %{name}",
        "hangar": "您的機庫是空的",
        "wishlist": "您的願望清單是空的",
        "features": "沒有可用功能",
        "fleetFeatures": "沒有可用的艦隊功能",
        "imports": "未找到匯入記錄",
        "transfers": "暫無轉移"
      },
      "actions": {
        "reset": "Reset Filters/Pages",
        "resetPage": "Go to First Page"
      },
      "texts": {
        "info": "我們未找到任何記錄。",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "目前沒有可用的自助服務功能。請稍後再查看，我們會定期新增新功能。",
        "fleetFeatures": "目前沒有艦隊可以自行啟用的功能。請稍後再查看，我們會定期新增新功能。"
      },
      "payouts": {
        "archivedTours": "沒有已封存的行程",
        "entries": "還沒有任何紀錄",
        "participants": "這個行程還沒有參與者",
        "transfers": "結算後即可看到誰付給誰",
        "tours": "還沒有行程"
      },
      "fleets": {
        "contracts": {
          "items": "尚未新增貨物。請填寫此合約需要的物品——空合約無法發布。"
        },
        "events": {
          "upcoming": "暫無即將開始的活動",
          "past": "還沒有活動結束",
          "archived": "沒有已封存的內容",
          "info": {
            "upcoming": "建立一個活動把艦隊召集起來——選好時間、新增席位，讓成員報名。",
            "past": "活動結束時間一過就會移到這裡。",
            "archived": "封存只是把活動從列表中移除，並不會刪除它。"
          }
        },
        "missions": {
          "active": "還沒有任務",
          "archived": "沒有已封存的內容",
          "info": {
            "active": "任務是一份可重複使用的計畫——包含小隊、艦船和席位——你可以由它產生活動。",
            "archived": "封存只是把任務從列表中移除，並不會刪除它。"
          }
        },
        "squadrons": {
          "headline": "還沒有中隊",
          "info": "中隊將艦隊劃分為若干分組，每個分組都有自己的成員、徽章和配色。對於同時屬於多個分組的成員，還可以使用小隊。"
        }
      }
    }
  }
}
